/**
 * UsefulLinks - Footer useful links section
 *
 * Data from centralized config (lib/footerConfig.ts)
 */

import { FooterLinkSection } from './FooterLinkSection'
import { usefulLinksSection } from '../../lib'

export function UsefulLinks() {
  return <FooterLinkSection data={usefulLinksSection} />
}
